var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankBalanceMinimum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3467,
    cy: 35.5,
    r: 35,
    fill: "#FFE0EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28841_2463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9744 28.1615H43.0263L42.9737 26.3025H40.3938L42.8186 21.2913L40.0754 21.0617L37.666 22.9086L38.4694 20.8201L35.6576 20.5L34.7354 23.1099L33.2199 21.0892L29.051 20.9445L31.8095 26.3033L29.3194 26.2233V28.1607H31.719C26.6012 31.1561 22.9141 38.9857 22.9141 43.2153C22.9141 48.5175 28.7043 51.5 35.8459 51.5C42.9875 51.5 48.7777 48.5175 48.7777 43.2153C48.7785 38.9857 45.0921 31.1569 39.9744 28.1615ZM36.9273 45.7589V47.5945H35.1629V45.885C33.957 45.8325 32.7867 45.5059 32.1029 45.1115L32.6428 43.0068C33.3985 43.4214 34.4614 43.7981 35.6309 43.7981C36.6565 43.7981 37.3589 43.402 37.3589 42.6835C37.3589 41.9973 36.7834 41.5649 35.4515 41.1163C33.5246 40.4689 32.2112 39.5677 32.2112 37.8234C32.2112 36.2392 33.3274 34.9961 35.2534 34.6195V32.9092H37.0178V34.4934C38.2229 34.5484 39.0344 34.7981 39.6276 35.0867L39.1055 37.1211C38.6375 36.9238 37.8091 36.5084 36.5135 36.5084C35.3432 36.5084 34.9649 37.0119 34.9649 37.5155C34.9649 38.1104 35.5953 38.4878 37.1253 39.0641C39.2664 39.8223 40.1312 40.81 40.1312 42.4313C40.132 44.0309 38.9972 45.3993 36.9273 45.7589Z",
    fill: "#DC3545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28841_2463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(20.3467 20.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBalanceMinimum);
export default __webpack_public_path__ + "static/media/BankBalanceMinimum.5c4adf9aef0e12e7f8efefd2438d94ba.svg";
export { ForwardRef as ReactComponent };